import { useHintsContext } from '../components/Hints/context.esm.js';

function useHints(id) {
  var _useHintsContext = useHintsContext(),
      setVisibleGroup = _useHintsContext.setVisibleGroup;

  var open = function open(overrideId) {
    if (overrideId === void 0) {
      overrideId = id;
    }

    setVisibleGroup(overrideId);
  };

  return {
    open: open
  };
}

export { useHints };
//# sourceMappingURL=use-hints.esm.js.map
